module.exports = __webpack_public_path__ + "static/media/9DESA4.f10253d2.jpg";